module.exports = __webpack_public_path__ + "img/fshrx10t.8eaaf00a.png";